import { clsx } from "clsx";

import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeContentSummary,
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import styles from "./ABTestBlock.module.scss";

// TODO: update type to import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";
// and follow up updateContactBlock or the IVR blocks work

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.ABTest).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.ABTest);

export function ABTestBlock({ data }: { data?: any }): JSX.Element {
    const isActive = Boolean(!!data?.testName || data?.empty);
    const hasVariants = !!data?.variants?.variant1;

    const nodeTitle = isActive && data?.testName ? "A/B Test" : "Logic";

    return (
        <BlockContainer variant={BLOCK_VARIANT} icon={BLOCK_ICON} contentClassName={styles.ABTestContent}>
            <BlockTitle nodeData={data} fallBackDisplay={nodeTitle}></BlockTitle>
            <BlockContent
                isActive={isActive}
                className={clsx({
                    [styles.ABTestNode]: hasVariants,
                    [styles.empty]: !isActive,
                })}
            >
                {getJourneyNodeContentSummary(NodeType.ABTest, data)}
            </BlockContent>
        </BlockContainer>
    );
}
